/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2023 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React from "react";
import { createPortal } from "react-dom";
import { ToastNotification } from "carbon-components-react";
import { AppMsg } from "../utils";
import "./ChangePasswordModal.scss";
const cssBase = "change-password-notification";

class ChangePasswordNotification extends React.PureComponent {
  render() {
    const { dir, handleNotificationCloseButton } = this.props;
    return (
      <>
        {createPortal(
          <div className={`${cssBase}--notification`}>
            <ToastNotification
              kind="success"
              dir={dir}
              lowContrast
              hideCloseButton={false}
              notificationType="toast"
              title={""}
              subtitle={AppMsg.getMessage(AppMsg.NEW_PASSWORD_CREATED)}
              key={"notification" + Math.floor(Math.random() * 1000)}
              timeout={5000}
              onClose={handleNotificationCloseButton}
              iconDescription={AppMsg.getMessage(AppMsg.CLOSE)}
            />
          </div>,
          document.body
        )}
      </>
    );
  }
}

export default ChangePasswordNotification;
